const ThemeTypoModal = ({ selectionType, selectedData, setShowViewModal }) => {
    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{selectionType}</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowViewModal(false)}
                        ></button>
                    </div>
                    <div className="modal-body" style={{
                        height: 'calc(100vh - 200px)',
                        overflow: 'auto'
                    }}>
                        {(selectionType == 'Theme') ? (<table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Theme</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedData?.sort((a, b) => a?.theme?.localeCompare(b?.theme))?.map(m => (
                                    <tr key={m.id}>
                                        <td>{m.theme}</td>
                                        <td>{m.description}</td>
                                    </tr>))}
                            </tbody>
                        </table>) : (<table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Typology</th>
                                    <th>Relevance</th>
                                    <th>Characteristics</th>
                                    <th>Location</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedData?.sort((a, b) => a?.typology?.localeCompare(b?.typology))?.map(m => (
                                    <tr key={m.id}>
                                        <td>{m.typology}</td>
                                        <td>{m.relevance}</td>
                                        <td>{m.characteristics}</td>
                                        <td>{m.locations}</td>
                                    </tr>))}
                            </tbody>
                        </table>)}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowViewModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ThemeTypoModal;